import { Link, Typography } from '@material-ui/core'

import { ACCOUNTING_OFFBOARDING_REQUEST_FORM } from '../../../helpers/constants'
import { hasPermission, Permissions } from '../../../Permissions'

export const TeamTransitions = {
  initiate_offboarding: {
    transitionString: 'Initiate offboarding',
    transitionAction: 'offboard',
    confirmationMessage: (team: any) => {
      return (
        <>
          <Typography>
            {team.is_premium && (
              <>
                Once offboarding is initiated:
                <br />
                &#8226; All active drivers in the fleet will be deactivated
                <br />
                &#8226; All truck insurance policies will be terminated
                <br />
                &#8226; All ELDs will be deactivated in Motive
              </>
            )}
            {!team.is_premium && (
              <>Once offboarding is initiated, all active drivers in the fleet will be deactivated.</>
            )}
            <br />
            <br />
            If you haven’t already, you’ll need to submit an&nbsp;
            <Link href={ACCOUNTING_OFFBOARDING_REQUEST_FORM} target={'_blank'}>
              Accounting offboarding request
            </Link>
            .
          </Typography>
        </>
      )
    },
    transitionTitle: () => {
      return 'Initiate offboarding'
    },
  },
  offboard: {
    transitionString: 'Offboarded',
    transitionAction: 'offboard',
    confirmationMessage: () => {
      return ''
    },
    transitionTitle: () => {
      return 'Churn'
    },
  },
  reapply: {
    transitionString: 'Reapply',
    transitionAction: 'reapply',
    confirmationMessage: () => {
      return 'Move this team to the “Applying” status?'
    },
    transitionTitle: () => {
      return 'Reapply'
    },
  },
  reonboard: {
    transitionString: 'Reonboard',
    transitionAction: 'reonboard',
    confirmationMessage: () => {
      return 'Move this team to the “Applying” status?'
    },
    transitionTitle: () => {
      return 'Reonboard'
    },
  },
}

export const TeamFSMTransitions: Record<string, any> = {
  APPLYING: [TeamTransitions.initiate_offboarding],
  ONBOARDING: [TeamTransitions.initiate_offboarding],
  APPROVED: [TeamTransitions.initiate_offboarding],
  OFFBOARDING: [TeamTransitions.offboard, TeamTransitions.reonboard],
  OFFBOARDED: [TeamTransitions.reonboard],
  DEACTIVATED: [TeamTransitions.reonboard],
  PROCESS_ABORTED: [TeamTransitions.reapply],
}

export const getTeamTransitionProps = (team: any, permissions: any) => {
  const isProcessAborted = team.is_team_process_aborted
  const canReonboardTeam = hasPermission(permissions || [], Permissions.ChangeTeam)

  let transitions: any[] = []
  if (isProcessAborted) {
    transitions = transitions.concat(TeamFSMTransitions['PROCESS_ABORTED'])
  }

  transitions = TeamFSMTransitions[team.status] || []
  if (!canReonboardTeam) {
    transitions = transitions.filter((transition) => transition.transitionAction !== 'reonboard')
  }

  return transitions
}

export const UnapproveTeamReasons = {
  UNSAFE_DRIVING: {
    id: 'UNSAFE_DRIVING',
    name: 'Unsafe Driving (DOT/road safety failures, unsatifactory ELD tracking)',
  },
  PERFORMANCE_RELATED: {
    id: 'PERFORMANCE_RELATED',
    name: 'Performance Related (aborted loads, high percentage fall offs, etc.)',
  },
  PERSONAL_ISSUES: { id: 'PERSONAL_ISSUES', name: 'Personal Issues (health, family, etc.)' },
  BEHAVIORAL_ISSUES: { id: 'BEHAVIORAL_ISSUES', name: 'Behavioral Issues (unprofessionalism, misconduct)' },
  PASSIVE_CHURN: { id: 'PASSIVE_CHURN', name: 'Passive Churn (unresponsive, rogue)' },
  BETTER_OPPORTUNITY: { id: 'BETTER_OPPORTUNITY', name: 'Competition/Better Opportunity' },
  FINANCIAL_LIMITATION: {
    id: 'FINANCIAL_LIMITATION',
    name: 'Financial Limitations (failure to pay rental or truck maintenance)',
  },
  UNMET_FINANCIAL_EXPECTATION: {
    id: 'UNMET_FINANCIAL_EXPECTATION',
    name: 'Unmet Financial Goals (unhappy with load price and availability)',
  },
  POOR_CT_CUSTOMER_SERVICE: { id: 'POOR_CT_CUSTOMER_SERVICE', name: 'Poor CT customer service' },
  TECHNICAL_CHALLENGES: { id: 'TECHNICAL_CHALLENGES', name: 'Technical challenges/Problem with App' },
  RETIREMENT: { id: 'RETIREMENT', name: 'Retirement' },
  COMPLIANCE_DISQUALIFICATION: {
    id: 'COMPLIANCE_DISQUALIFICATION',
    name: 'Compliance Disqualification (drug screening, suspended license or registration)',
  },
  OTHER: { id: 'OTHER', name: 'Other (Enter reason in the note)' },
}
